module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Villmergen-be39af968281187002ac76867f93f20a.svg";